import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref, onValue, set } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDhJe7nuGn1puyaELZWC4B1lzJMfds9ngE",
  authDomain: "conceptomotives-imt.firebaseapp.com",
  databaseURL: "https://conceptomotives-imt-default-rtdb.firebaseio.com",
  projectId: "conceptomotives-imt",
  storageBucket: "conceptomotives-imt.firebasestorage.app",
  messagingSenderId: "208079666899",
  appId: "1:208079666899:web:4101a66ad7d9f8a0581e26",
  measurementId: "G-T3F78Q050M"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getDatabase();

export { app, auth, db, signInWithEmailAndPassword, onValue, ref, set };